import { Grid } from '@mui/material'
import { Business as BusinessIcon } from '@mui/icons-material'
import { useStructures } from '../../Structures/useStructures'
import { createStructureRoute } from '../../app-routes'
import StatusCard from '../../components/StatusCard'
import { Structure } from '../../Structures/types'
import { DeviceStatus } from '@/types'

const getStructureStatus = (structure: Structure): DeviceStatus => {
  let status: DeviceStatus = 'OKAY'
  let allDevices = 0
  structure.units.forEach((unit) => {
    allDevices = unit.devices.length + allDevices
  })
  if (!allDevices) {
    status = 'NO_DEVICES'
    return status
  }
  structure.units.forEach((unit) => {
    if (unit.devices.some((device) => device.device_status === 'ERROR')) {
      status = 'ERROR'
      return status
    }
    if (unit.devices.some((device) => device.device_status === 'WARNING')) {
      status = 'WARNING'
      return status
    }
  })

  return status
}

const getStructureErrorMessage = (structure: Structure, status: DeviceStatus): string[] => {
  let errMsg: string[] = []
  structure.units.forEach((unit) => {
    unit.devices.forEach((device) => {
      errMsg.push(`${unit.name} · ${device.name} · ${device.device_status_strings.join(',')}`)
    })
  })

  return errMsg
}

const Home = () => {
  const { structures } = useStructures()

  return (
    <Grid container rowSpacing={3} columnSpacing={3}>
      {structures &&
        structures.map((structure: Structure) => {
          const status = getStructureStatus(structure)

          return (
            <Grid item xs="auto">
              <StatusCard
                key={structure.id}
                link={createStructureRoute(structure.id)}
                title={structure.name}
                subtitle={`${structure.units.length} Units`}
                status={status}
                icon={<BusinessIcon sx={{ width: 60, height: 60 }} />}
                errorMessage={getStructureErrorMessage(structure, status)}
              />
            </Grid>
          )
        })}
    </Grid>
  )
}

export default Home
